<template>
    <div class="modal__container">
        <div class="modal__address">
            <span v-if="isMobileScreen" class="courier_new_strip"></span>
            <div class="modal__address_container">
                <div class="modal__address_list">
                    <div class="modal__address_list_block">
                        <span class="modal__address_title">{{ __t('O.DELIVERY_ADDRESS') }}</span>
                        <div class="modal__address_block">
                            <div class="modal__address_block_info">
                                <div class="modal__address_block_info_text">
                                    <!--                                    <input type="text" class="modal__address_block_info_text_input"-->
                                    <!--                                           v-model="addressDelivery.address"-->
                                    <!--                                           :placeholder="addressText"-->
                                    <!--                                           @input="inputSearchAddress"-->
                                    <!--                                    >-->
                                    <label class="modal__address_block_info_text_input">
                                        <v_select
                                            class="input__item"
                                            label="text"
                                            v-model="addressValue"
                                            :options="searchRest"
                                            @search="inputSearchAddress">
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v_select>
                                    </label>
                                </div>
                                <span class="modal__address_block_info_label">{{ addressText }}</span>
                            </div>
                        </div>
                        <div class="modal__address_block">
                            <div class="modal__address_block_info">
                                <div class="modal__address_block_info_text">
                                    <input type="text" class="modal__address_block_info_text_input"
                                           v-model="addressDelivery.house"
                                           :placeholder="houseText"
                                    >
                                </div>
                                <span class="modal__address_block_info_label">
                                {{ houseText }}
                            </span>
                            </div>
                            <div class="modal__address_block_info">
                                <div class="modal__address_block_info_text">
                                    <input type="text" class="modal__address_block_info_text_input"
                                           v-model="addressDelivery.entrance"
                                           :placeholder="entranceText">
                                </div>
                                <span class="modal__address_block_info_label">
                                {{ entranceText }}
                            </span>
                            </div>
                            <div class="modal__address_block_info">
                                <div class="modal__address_block_info_text">
                                    <input type="text" class="modal__address_block_info_text_input"
                                           v-model="addressDelivery.flat"
                                           :placeholder="flatText">
                                </div>
                                <span class="modal__address_block_info_label">
                                {{ flatText }}
                            </span>
                            </div>
                        </div>
                    </div>
                    <div class="modal__address_buttons">
                        <button v-if="!isMobileScreen" class="modal__address_buttons_button"
                                @click.prevent="clickClose">
                            <span class="modal__address_buttons_button_text">
                                {{ __t('O.CLOSE') }}
                            </span>
                        </button>
                        <button class="modal__address_buttons_button color" @click.prevent="clickSave">
                            <span class="modal__address_buttons_button_text">
                                {{ __t('O.SAVE') }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {screenSize} from "../../../mixins/screenSize";
import {touchEvent} from "../../../mixins/touchEvent";
import v_select from 'vue-select';
import {createHelpers} from "vuex-map-fields";
import {useToast} from "vue-toastification";
const toast = useToast();
const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "modal_address",
    props: {
        addressInfo: {
            type: Object,
            required: true,
        }
    },
    emits: ['close_address', 'save_address'],
    components: {v_select},
    mixins: [screenSize, touchEvent],
    data() {
        return {
            addressDelivery: null,
            searchRest: [],
            addressValue: '',
        }
    },
    beforeMount() {
        this.addressDelivery = {...this.addressInfo};
        if(this.addressDelivery.address){
            this.addressValue = this.addressDelivery.address;
        }
    },
    methods: {
        touchStartEvent(){
            if(this.touchElementClass === 'modal__container') {
                setTimeout(() => {
                    this.clickClose();
                }, 200);
            }
        },
        clickClose() {
            this.$emit('close_address');
        },
        clickSave() {
            if(this.addressValue.text) {
                this.addressDelivery.address = this.addressValue.text;
            }
            this.$emit('save_address', this.addressDelivery);
        },
        moveTouchDown() {
            this.$emit('close_address');
        },
        async inputSearchAddress(search, loading) {
            if (search.length > 3) {
                loading(true);
                await $api.get('/internal/delivery/restaurants/'+ this.orderInfoByLocation.selectLocation.id +'/suggest/' + search)
                    .then(({data}) => {
                        loading(false);
                        if (data.status === 'operation_success') {
                            this.searchRest = data.data;
                        }
                    }).catch(e => {
                        toast.error(__t('O.ERROR_SEARCH_ADDRESS') + e.toString());
                        loading(false);
                    });
            }
        }
    },
    computed: {
        ...mCouriers([
            'orderInfoByLocation',
            'searchAddressInput',
        ]),
        addressText() {
            return `${this.__t('O.CITY_STREET')}`;
        },
        houseText() {
            return `${this.__t('O.HOUSE')}`;
        },
        entranceText() {
            return `${this.__t('O.ENTRANCE')}`;
        },
        flatText() {
            return `${this.__t('O.FLAT')}`;
        },
    },
}
</script>
<style>

.vs__dropdown-toggle {
    border: none;
    box-shadow: none;
}

.vs__selected-options {
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
}

</style>
